// Vendors
import React from 'react';
import { IntlProvider } from 'react-intl';
// Hooks
import { useInternationalizationHook } from './hooks/internationalization.hook';
// Types
import { ReactChildrenType } from '@openbank/ziniaweb-ui-core-models';

const InternationalizationProvider = ({
  children,
}: ReactChildrenType): React.JSX.Element | null => {
  const { fetching, locale, translations: messages } = useInternationalizationHook();

  return fetching ? null : <IntlProvider {...{ locale, messages }}>{children}</IntlProvider>;
};

export { InternationalizationProvider };
